import {getFormattedDateTime} from "@ots-frontend/ots-data";
import {IconCalendarRepeat} from "@tabler/icons-react";
import {OtsBadge, type OtsBadgeSize} from "../components/OtsBadge";

export type DispatchCarryoverBadgeProps = {
  /** How many days the carryover job has moved the dispatch forward. */
  carryoverCount?: number;
  /** The scheduled time before the first carryover. */
  originalScheduleDttm?: number;
  size?: OtsBadgeSize;
};

export const getDispatchCarryoverLabel = (carryoverCount: number, originalScheduleDttm?: number) => {
  const times = carryoverCount === 1 ? "once" : `${carryoverCount} times`;
  return originalScheduleDttm != null
    ? `Carried over ${times}, originally ${getFormattedDateTime(originalScheduleDttm)}`
    : `Carried over ${times}`;
};

/** Marks a dispatch the carryover job moved to a later day because its driver was off shift. Renders nothing otherwise. */
export const DispatchCarryoverBadge = ({carryoverCount, originalScheduleDttm, size = "compact"}: DispatchCarryoverBadgeProps) => {
  if (!carryoverCount || carryoverCount < 1) return null;

  const label = getDispatchCarryoverLabel(carryoverCount, originalScheduleDttm);
  return (
    // one accessible name for the whole badge, also shown as a hover hint
    <span role="img" aria-label={label} title={label} className="inline-flex">
      <OtsBadge tone="warning" size={size} icon={<IconCalendarRepeat/>}>
        {carryoverCount}×
      </OtsBadge>
    </span>
  );
};
